import fetch from 'isomorphic-fetch';
import Config from '../../config/'

const API = {
  data: {
    async getSetting(obj) {
      let response = await fetch(`${Config.api}/api/dashboard/`, {
        headers: new Headers({
          credentials: 'include',
          Pragma: 'no-cache'
        }),
      });

      const status = response.status;
      let data = await response.json();

      return {
        data: data.response,
        status: status
      };
    },
    async getDate(obj) {
      let response = await fetch(`${Config.api}/api/datemax/`, {
        headers: new Headers({
          credentials: 'include',
          Pragma: 'no-cache'
        }),
      });

      const status = response.status;
      let data = await response.json();
      return {
        data: data,
        status: status
      };
    },
    async setTourViewded(tour) {
      const response = await fetch(`/api/tour`, {
        method: 'PUT',
        headers: new Headers({
          'Content-Type': 'application/json',
          Accept: 'application/json'
        }),
        body: JSON.stringify(tour)
      });
      const status = response.status;
      const data = await response.json();
      return { data: data.response, status: status };
    },
    async getTaskManagerIndicators() {
      let response = await fetch(`${Config.api}/api/taskmanagerindicators/`, {
        headers: new Headers({
          credentials: 'include',
          Pragma: 'no-cache'
        }),
      });

      const status = response.status;
      let data = await response.json();

      return {
        data: data.response,
        status: status
      };
    }
  },
};
export default API;





// WEBPACK FOOTER //
// ./source/client/actions/dashboard/api/index.js